<template>
  <div class="flex flex-col flex-1">
    <BaseHeader />
    <slot />
    <BaseFooter />
  </div>
</template>
